import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_2 = {
  key: 0,
  class: "text-orange-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPark = _resolveComponent("IconPark")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.campaignId && _ctx.settingsLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.bid !== null)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$n(_ctx.bid, 'bid')), 1)
            ])), [
              [
                _directive_tooltip,
                _ctx.$t('bid') + ' (' + _ctx.bidLabel + ')',
                void 0,
                { left: true }
              ]
            ])
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_IconPark, {
              key: 1,
              class: "text-blue-600 blinking",
              type: "loading",
              theme: "outline",
              size: _ctx.iconSize
            }, null, 8, ["size"]))
          : _withDirectives((_openBlock(), _createBlock(_component_IconPark, {
              key: 2,
              class: _normalizeClass(["cursor-pointer", _ctx.blocked ? 'text-green-600' : 'text-pink-600']),
              type: _ctx.blocked ? 'check' : 'close',
              theme: "outline",
              size: _ctx.iconSize,
              onClick: _ctx.toggle
            }, null, 8, ["class", "type", "size", "onClick"])), [
              [
                _directive_tooltip,
                _ctx.$t(_ctx.blocked ? 'unblock_subid' : 'block_subid'),
                void 0,
                { left: true }
              ]
            ])
      ]))
    : _createCommentVNode("", true)
}